/** @format */

import { Injectable, signal } from '@angular/core';
import { HmfSnackbarComponent } from '@dsg-tech/homefield-angular';

export type AppSnackbarOptions = {
	duration?: number;
	showAboveDrawers?: boolean;
};

@Injectable({
	providedIn: 'root'
})
export class AppSnackbarService {
	readonly defaultOptions: AppSnackbarOptions = {
		duration: 4000,
		showAboveDrawers: false
	};

	private snackBarComponent: HmfSnackbarComponent | undefined;

	private readonly _message = signal('');
	message = this._message.asReadonly();

	private readonly _options = signal(this.defaultOptions);
	options = this._options.asReadonly();

	private timeout = undefined;

	showSnackbar(message: string, options: AppSnackbarOptions = this.defaultOptions) {
		this._message.set(message);
		this._options.set(options);
		this.snackBarComponent?.openSnackbar();
		if (options.duration) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(
				() => this.snackBarComponent?.closeSnackbar(),
				options.duration
			);
		}
	}

	register(snackbarComponent: HmfSnackbarComponent): void {
		this.snackBarComponent = snackbarComponent;
	}
}
